<template>
<div>
  <div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
    <div class="row">
      <div class="col-sm-12">
        <div id="resultsHeader">
          <div class="checkboxCol"></div>
          <div class="normalCol">Job No</div>
          <div class="normalCol">Type</div>
          <div class="normalCol">Status</div>
          <div class="smallCol">Invoiced</div>
          <div class="normalCol">Date</div>
        </div>
      </div>
    </div>

    <div class="row" v-for="order in orders" :key="order.id">
      <div v-if="order.type=='Job'">
        <router-link :to="{name: 'OrdersEdit', params: { id: order.id }}">
        <div class="col-sm-12">
          <div id="resultsBody">
            <div class="checkboxCol"></div>
          <div class="normalCol">{{ order.order_number }}</div>
          <div class="normalCol">Job</div>
          <div class="normalCol"><span class="itemStatus" :class="order.status">{{ order.status }}</span></div>
          <div class="smallCol"><span class="emptyPoint" :class="order.invoice_status"></span></div>
          <div class="normalCol">{{ order.created_at | formatDate }}</div>
          </div>
        </div>
        </router-link>
      </div>
      <div v-if="order.type=='Refrigeration Maintenance'">
        <router-link :to="{name: 'OrdersRefridgerationEdit', params: { id: order.id }}">
        <div class="col-sm-12">
          <div id="resultsBody">
            <div class="checkboxCol"></div>
          <div class="normalCol">{{ order.order_number }}</div>
          <div class="normalCol">Refrigeration Checklist</div>
          <div class="normalCol"><span class="itemStatus" :class="order.status">{{ order.status }}</span></div>
          <div class="smallCol"><span class="emptyPoint" :class="order.invoice_status"></span></div>
          <div class="normalCol">{{ order.created_at | formatDate }}</div>
          </div>
        </div>
        </router-link>
      </div>
      <div v-if="order.type=='Maintenance'">
        <router-link :to="{name: 'MaintenanceEdit', params: { id: order.id }}">
        <div class="col-sm-12">
          <div id="resultsBody">
            <div class="checkboxCol"></div>
          <div class="normalCol">{{ order.order_number }}</div>
          <div class="normalCol">Large Maintenance</div>
          <div class="normalCol"><span class="itemStatus" :class="order.status">{{ order.status }}</span></div>
          <div class="smallCol"><span class="emptyPoint" :class="order.invoice_status"></span></div>
          <div class="normalCol">{{ order.created_at | formatDate }}</div>
          </div>
        </div>
        </router-link>
      </div>
      <div v-if="order.type=='Air Con'">
        <router-link :to="{name: 'OrdersAirconEdit', params: { id: order.id }}">
        <div class="col-sm-12">
          <div id="resultsBody">
            <div class="checkboxCol"></div>
          <div class="normalCol">{{ order.order_number }}</div>
          <div class="normalCol">Air Con</div>
          <div class="normalCol"><span class="itemStatus" :class="order.status">{{ order.status }}</span></div>
          <div class="smallCol"><span class="emptyPoint" :class="order.invoice_status"></span></div>
          <div class="normalCol">{{ order.created_at | formatDate }}</div>
          </div>
        </div>
        </router-link>
      </div>
    </div>
  </div>
  <div class="paginationContainer">
    <div class="row">
      <div class="col-sm-12">
        <div align="right">
          Showing page {{ pagination.current_page }} of {{ pagination.last_page }} <a class="btnPaginate" @click.prevent="getOrders(pagination.prev_page_url)">Previous</a> <a class="btnPaginate" @click.prevent="getOrders(pagination.next_page_url)">Next</a>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      orders: {},
      pagination: {}
    }
  },
  created () {
    this.getOrders()
  },
  methods: {
    getOrders (page) {
      if (typeof page === 'undefined') {
        page = `/api/companies/${this.$route.params.id}/orders?page=1`
      }
      axios
        .get(page)
        .then((res) => {
          this.orders = res.data.data
          this.pagination = res.data
          console.log(this.pagination)
        })
    }
  }
}
</script>
